
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { PermissionCode } from '@/types';
import { currentUserHasPermission } from '@/helpers';

@Component
export default class SupplyHistoryIcon extends Vue {
  @Prop({ type: Boolean, default: false }) readonly supply1!: boolean;
  @Prop({ type: String, default: '' }) readonly supply1text!: string;
  @Prop({ type: Boolean, default: false }) readonly supply2!: boolean;
  @Prop({ type: String, default: '' }) readonly supply2text!: string;
  @Prop({ type: Boolean, default: false }) readonly supply3!: boolean;
  @Prop({ type: String, default: '' }) readonly supply3text!: string;
  @Prop({ type: Boolean, default: false }) readonly supply4!: boolean;
  @Prop({ type: String, default: '' }) readonly supply4text!: string;
  @Prop({ type: Boolean, default: false }) readonly supply5!: boolean;
  @Prop({ type: String, default: '' }) readonly supply5text!: string;

  hasPermission(codename: PermissionCode) {
    return currentUserHasPermission(codename);
  }
}
